import React from 'react';
import './SupplierRewards.css';

export default function SupplierRewards() {
  return (
    <section className="supplier-rewards-section section-padding" id="rewards">
      <div className="container supplier-rewards-container">
        <div className="rewards-grid">
          {/* Left Column: Heading */}
          <div className="rewards-heading-panel">
            <h2 className="rewards-title">
  <span className="rewards-title-line1">Exclusive Supplier+ Rewards for the</span>
  <span className="rewards-title-line2">first 30 days</span>
</h2>
            
          </div>

          {/* Right Column: Cards */}
          <div className="rewards-cards-panel">
            {/* Card 1 */}
            <div className="reward-card">
              <div className="reward-card-header">
                <div className="reward-icon-wrapper visibility-bg">
                  <img src="https://static.wixstatic.com/media/fe689e_d6c1b7e4f74c4772a6f03114a9235b5e~mv2.jpg/v1/fill/w_70,h_66,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-23%20at%205_57_edited.jpg" alt="Free catalog visibility of ₹599" className="reward-card-img-icon" />
                </div>
                <h3 className="reward-card-title">Free catalog visibility of ₹599</h3>
              </div>
              <p className="reward-card-text">
                Run advertisements for your catalogs to increase the visibility of your products and get more orders. Currently, not available for sellers who don't have a Regular GSTIN.
              </p>
            </div>

            {/* Card 2 */}
            <div className="reward-card">
              <div className="reward-card-header">
                <div className="reward-icon-wrapper no-charges-bg">
                  <img src="https://static.wixstatic.com/media/fe689e_e73f237c80224047a3dba845dfeadcca~mv2.jpg/v1/fill/w_68,h_66,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Screenshot%202025-01-23%20at%206_02_edited.jpg" alt="No Order Cancellation Charges" className="reward-card-img-icon" />
                </div>
                <h3 className="reward-card-title">No Order Cancellation Charges</h3>
              </div>
              <p className="reward-card-text">
                Cancel orders that you can't fulfil for unforeseen reasons without worrying about penalties.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
